<template>
  <div class="modalWindow-box">
    <div class="modalWindow1" v-drag>
      <div class="modalWindow__top">
        <p class="modalWindow--txt1">
          告诉我们出错的内容
          <span
            class="modalWindow--close1 fr"
            @click="close('cear')"
          ></span>
        </p>
      </div>
      <div class="main">
        <el-form
          :model="formInline"
          label-width="70px"
          ref="feedForm"
          :rules="feedRule"
        >
          <el-form-item class="noMar testArea" prop="textarea">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="formInline.textarea"
              maxlength="400"
            >
            </el-input>
            <span class="cor-9 fz-14">其它选项（选填）</span>
          </el-form-item>
          <el-form-item label="网址" prop="webAdd">
            <el-input
              type="text"
              placeholder="请输入内容"
              v-model="formInline.webAdd"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="附上截图">
            <el-upload
              class="upload-demo"
              :action="url()"
              :headers="header"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              accept=".jpg,.jpeg,.png,.JPEG,.PNG"
              :limit="3"
              :file-list="imgList"
              :on-exceed="onExceed"
              :on-change="onChange"
              :before-upload="beforeAvatarUpload"
            >
              <div class="uploadBtn">
                <div class="uploadBtn-img"></div>
                <span>上传图片</span>
              </div>
            </el-upload>
            <div class="imgList" v-if="imgList && imgList.length > 0">
              <div
                class="img-box"
                v-for="(item, index) in imgList"
                :key="index"
              >
                <span
                  class="el-icon-close spanIcon"
                  @click="clear(item, index)"
                ></span>
                <img :src="item.url" alt="" />
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="fz-14 cor-9 feedInfo">
          除了您提交的上述信息外，我们还将采集您的浏览器和操作系统信息。中华医学会杂志社在收到您的反馈问题后与您取得联系，您可以通过个人中心消息中的系统反馈看到我们的回复。
        </div>
      </div>
      <div class="main-btm">
        <div class="line-between">
          <span class="left"></span>
          <span class="line-dian"></span>
          <span class="right"></span>
        </div>
        <div style="text-align: center">
          <el-button
            class="btn"
            @click="close()"
            >取 消</el-button
          >
          <el-button
            class="btn1 btn"
            @click="saveFeed('feedForm')"
            >确 认</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Post, Get } from "@/api/axios";
export default {
  props: ["typeId"],
  data() {
    return {
      formInline: {
        textarea: "",
        webAdd: "",
      },
      feedRule: {
        textarea: [
          {
            required: true,
            message: "请先输入内容，再进行提交",
            trigger: "blur",
          },
        ],
        //   webAdd: [
        //     { required: true, message: '请输入活动名称', trigger: 'blur' },
        //   ],
      },
      header: {
        authToken: sessionStorage.getItem("token"),
      },
      fileId: "",
      imgList: [],
      isFeed: false,
    };
  },
  created() {
    // this.getHeight()
  },
  mounted() {
    // window.addEventListener('scroll', this.getHeight)
  },
  destroyed() {
    // window.removeEventListener('scroll', this.getHeight, false)
  },
  methods: {
    // getHeight(){
    //   this.heightNUm = document.getElementsByTagName('body')[0].offsetHeight
    // },
    //   关闭反馈弹窗
    close(v) {
      this.$bus.$emit("upData");
      this.$emit("close", v);
    },
    onExceed(files, lists) {
      if (this.imgList.length >= 3) {
        this.$message.error("最多上传3张！");
        return false;
      }
    },
    beforeAvatarUpload(res, file) {
      let isLt2MBs = res.size / 1024 / 1024 < 1;
      let s = "";
      if (!isLt2MBs) {
        this.$message.error("上传文件大小不能超过 1MB!");
        s = false;
      }
      return s;
    },
    onChange() {
      if (this.imgList.length >= 3) {
        this.$message.error("最多上传3张！");
        return false;
      }
    },
    handleAvatarSuccess(datas, file) {
      if (datas && datas.data && datas.data.ID) {
        let url = "/member/spc/v1/files/getFilePath?recordId=" + datas.data.ID;
        Get(url).then((res) => {
          if (res.data.filePath) {
            let obj = {
              id: datas.data.ID,
              url: res.data.filePath,
            };
            this.imgList.push(obj);
            // this.imgSrc = res.data.filePath;
          }
        });
      }
    },
    // 删除图片
    clear(item, index) {
      this.imgList.splice(index, 1);
    },
    // 图片上传接口地址
    url() {
      let url = "/member/spc/v1/files/fileUpload";
      return url;
    },
    // 保存反馈
    saveFeed(formName) {
      // 获取浏览器信息
      var Sys = {};
      var ua = navigator.userAgent.toLowerCase();
      var s;
      (s = ua.match(/msie ([\d.]+)/))
        ? (Sys.ie = s[1])
        : (s = ua.match(/firefox\/([\d.]+)/))
        ? (Sys.firefox = s[1])
        : (s = ua.match(/chrome\/([\d.]+)/))
        ? (Sys.chrome = s[1])
        : (s = ua.match(/opera.([\d.]+)/))
        ? (Sys.opera = s[1])
        : (s = ua.match(/version\/([\d.]+).*safari/))
        ? (Sys.safari = s[1])
        : 0;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let strParams = {
            senderUserId: localStorage.getItem("memberId"),
            senderUserType: "C_USER_SYSTEM",
            receverUserId: "1",
            receverUserType: "B_ADMIN_SYSTEM",
            content: this.formInline.textarea,
            source: this.typeId ? this.typeId : "4",
            type: "2",
            operatorId: localStorage.getItem("memberId"),
            operatorName: localStorage.getItem("loginName"),
            opinionContent: {
              picPath1: "",
              picPath2: "",
              picPath3: "",
              opinionContent: "",
              operateSystem: "",
              url: this.formInline.webAdd,
            },
          };
          if (Sys.ie) strParams.opinionContent.browserVersions = "ie" + Sys.ie;
          if (Sys.firefox)
            strParams.opinionContent.browserVersions = "firefox" + Sys.firefox;
          if (Sys.chrome)
            strParams.opinionContent.browserVersions = "chrome" + Sys.chrome;
          if (Sys.opera)
            strParams.opinionContent.browserVersions = "opera" + Sys.opera;
          if (Sys.safari)
            strParams.opinionContent.browserVersions = "safari" + Sys.safari;
          if (ua.indexOf("window") != -1)
            strParams.opinionContent.operateSystem = ua.substring(
              ua.indexOf("(") + 1,
              ua.indexOf(")")
            );
          if (ua.indexOf("mac") != -1)
            strParams.opinionContent.operateSystem = ua.substring(
              ua.indexOf("(") + 1,
              ua.indexOf(")")
            );
          strParams["opinionContent"].realUrl = location.href;

          if (this.imgList && this.imgList.length == 1) {
            strParams["opinionContent"].picPath1 = this.imgList[0].id;
          }
          if (this.imgList && this.imgList.length == 2) {
            strParams["opinionContent"].picPath1 = this.imgList[0].id;
            strParams["opinionContent"].picPath2 = this.imgList[1].id;
          }
          if (this.imgList && this.imgList.length == 3) {
            strParams["opinionContent"].picPath1 = this.imgList[0].id;
            strParams["opinionContent"].picPath2 = this.imgList[1].id;
            strParams["opinionContent"].picPath3 = this.imgList[2].id;
          }
          Post(
            "/member/spc/" + this.$version1 + "/saveFeedback",
            strParams,
            "isJson"
          ).then((res) => {
            if (res.status == 0) {
              this.close("up");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.noMar {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}

.cor-9 {
  color: #999;
}

.fz-14 {
  font-size: 14px;
}

.fz-12 {
  font-size: 12px;
}

.main {
  height: 380px;
  padding: 30px 20px 0;
  background: #fff;
  overflow-y: auto;
  .btns1 {
    margin-top: 40px;
  }

  .testArea {
    margin-bottom: 0;
    position: relative;

    /deep/ .el-form-item__error {
      position: absolute;
      top: -25px;
    }
  }

  /deep/ .el-textarea {
    textarea {
      height: 100px;
    }
  }

  /deep/ .el-form-item__label {
    text-align: left;
  }

  /deep/ .el-textarea__inner {
    font-family: inherit;
  }

  .feedInfo {
    line-height: 24px;
  }
}

.main-btm {
  padding: 10px 0 30px;
}

.modalWindow1 {

  .uploadBtn {
    margin-top: 2px;
    height: 36px;
    background-color: #f1f1f1;
    color: #a3a3a3;
    display: flex;
    padding: 8px 12px;
    transition-duration:0.3s;
    transition-property:all;
    span{
      margin-left: 5px;
      }
      .uploadBtn-img {
        margin-top: 1px;
        background: url("../../assets/img/icon_upload.png") no-repeat;
        height: 18px;
        width: 18px;
        background-size: 18px;
      }
    &:hover{
       background-color: #ffb266;
      color: #ffffff;
      .uploadBtn-img{
        background-image: url("../../assets/img/icon_upload_h.png");
      }
    }
  }


  .imgList {
    margin-top: 15px;
    .img-box {
      width: 100px;
      height: 100px;
      position: relative;
      display: flex;
      justify-content: center;
      display: inline-block;
      background: #fafafa;
      align-content: center;
      margin-right: 10px;

      .spanIcon {
        color: #999999;
        position: absolute;
        top: 3px;
        right: 3px;
        border-radius: 50%;
        background: #ffffff;
        padding: 3px;
        font-weight: bold;
        z-index: 5;
        cursor: pointer;

        &:hover {
          color: #52b8cc;
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

.modalWindow1 {
  .main {
    .el-form {
      .el-form-item {
        .el-form-item__content {
          .upload-demo {
            line-height: 20px;

            .el-upload {
              text-align: left;
            }
          }
        }
      }
    }
  }
}

.line-between {
  overflow: hidden;
  margin-bottom: 20px;
  position: relative;
  padding: 0px 20px;

  .line-dian {
    display: inline-block;
    width: 100%;
    height: 20px;
    background: url(../../assets/img/xfjl_tkbg.png) center repeat-x;
  }
  .left,
  .right {
    width: 20px;
    height: 20px;
    background: rgba(115, 115, 115, 0.85);
    border-radius: 50%;
    position: absolute;
  }
  .left {
    left: 0;
    transform: translateX(-50%);
  }
  .right {
    right: 0;
    transform: translateX(50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/feedback/index.vue